module.exports = __webpack_public_path__ + "img/93.4.NH3-N.51282f3a.png";